import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button, UIHeading5 } from '@cian/ui-kit';
import { useEventCallback } from '@cian/react-utils';
import { AuthorInfo } from '../../components/AuthorInfo';
import { selectBuilder, selectProjectId } from '../../selectors';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { trackPhoneOpen } from '../../utils/analytics';
import { getHousesCount, getProjectsCount } from './helpers';
import { CallbackContainer } from '../CallbackContainer';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';

export const AuthorInfoContainer = () => {
  const [phoneVisible, setPhoneVisible] = React.useState(false);
  const builder = useSelector(selectBuilder);
  const projectId = useSelector(selectProjectId);
  const lastYearConstructCount = getHousesCount(builder.lastYearConstructCount);
  const projectsCount = getProjectsCount(builder.projectsCount);

  const handleShowPhone = useEventCallback(() => {
    setPhoneVisible(true);
    trackPhoneOpen('Open_CSP_card_blockDeveloper', projectId);
  });

  return (
    <AuthorInfo
      {...builder}
      lastYearConstructCount={lastYearConstructCount}
      projectsCount={projectsCount}
      phoneButton={
        <PhoneButtonContainer
          button={<Button size="XS">Контакты подрядчика</Button>}
          contentRenderer={phone => <UIHeading5 whiteSpace="nowrap">{phone}</UIHeading5>}
          onShow={handleShowPhone}
        />
      }
      callbackButton={<CallbackContainer placement={ECallbackWidgetPlacement.Author} />}
      phoneVisible={phoneVisible}
    />
  );
};
